import { paths } from "helpers/paths";
import { deletedFilters } from "helpers/redux";
import { paramsObject } from "helpers/system";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/trucks";
import AddLogist from "./addLogist";
import { LogistHistory, LogistHistoryForm } from "./history";
import List from "./list";
import Show from "./show";

const historySource = {
    getItem: source.getCarLogistPeriod,
    index: source.getCarLogistPeriods,
    apply: source.applyCarLogistPeriod,
    delItem: source.deleteCarLogistPeriod,
};

export default class Trucks extends Component {
    componentWillUnmount() {
        this.props.clearParams("trucks", deletedFilters());
    }

    render() {
        const { match, location, history } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(rootUrl);
        const backToHistory = (counterpartyId) => history.push(paths.logistHistory(counterpartyId));
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={`${rootUrl}/:truckId/history/new`}
                        render={(rest) => (
                            <LogistHistoryForm
                                {...rest}
                                nofilter
                                transition="full"
                                title="Создание привязки логиста"
                                back={() => backToHistory(rest.match.params.truckId)}
                                source={historySource}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={`${rootUrl}/:truckId/history/:id`}
                        render={(rest) => (
                            <LogistHistoryForm
                                {...rest}
                                nofilter
                                transition="full"
                                title="Редактирование привязки логиста"
                                back={() => backToHistory(rest.match.params.truckId)}
                                source={historySource}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={`${rootUrl}/:truckId/history`}
                        render={(rest) => (
                            <LogistHistory
                                {...rest}
                                nofilter
                                transition="full"
                                title="История привязки логистов"
                                back={back}
                                source={historySource}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={`${match.path}/add-logist`}
                        render={() => <AddLogist {...this.props} back={back} />}
                    />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List
                                {...this.props}
                                isTable
                                transition="full"
                                nofilter
                                title="Список машин"
                                source={source}
                            />
                        )}
                    />
                    <Route
                        path={`${rootUrl}/:id`}
                        render={(rest) => {
                            const { history } = this.props;
                            const { from, logistId } = paramsObject(rest.location.search);
                            let backAction = back;
                            if (from && from === "logists" && logistId) {
                                backAction = () => history.push(paths.logistsShow(logistId));
                            }
                            return (
                                <Show {...rest} transition="full" title="Машина" back={backAction} source={source} />
                            );
                        }}
                    />
                </Switch>
            </div>
        );
    }
}
